import axios, { AxiosError, isAxiosError } from 'axios';
import isString from 'lodash/isString';

import { RestaurantApiResponseError, RestaurantApiError } from './types';

export const isRestaurantApiResponseError = (error: any): error is RestaurantApiResponseError => {
  return isAxiosError(error) && !!error.response && isString(error.response.data.msg);
};

export const buildRestaurantApiError = (error: AxiosError): RestaurantApiError => {
  return { apiUiMessage: isRestaurantApiResponseError(error) ? error.response.data.msg : null };
};

export const uploadFileToUrl = async (file: File, uploadUrl: string) => {
  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
};
